import * as React from 'react';
import {
    List,
    TextField,
    EditButton,
    Create,
    SimpleForm,
    TextInput,
    Edit,
    required
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

const userFilters = [<TextInput source="all" label="Rechercher" alwaysOn />];

export const SongLangList = (props) => (
    <List {...props} filters={userFilters} bulkActionButtons={false} sort={{ field: 'name', order: 'ASC' }} perPage={50} pagination={<AdminPagination />} exporter={false}>
        <AdminSelectableDatagrid>
            <TextField source="name" label="Nom" />
            <EditButton />
            <HumanDeleteButton fields={["name"]} fallback="cette langue" />
        </AdminSelectableDatagrid>
    </List>
);

export const SongLangEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["name"]} fallback="Fiche" />}>
        <SimpleForm redirect="list">
            <TextInput source="name" label="Nom" validate={required()} />
        </SimpleForm>
    </Edit>
);

export const SongLangCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput source="name" label="Nom" validate={required()} />
        </SimpleForm>
    </Create>
);
